import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import axios from 'axios';
import ConfigManager from '../managers/ConfigManager';

var MailService = /*#__PURE__*/function () {
  function MailService() {
    _classCallCheck(this, MailService);

    this.baseUrl = ConfigManager.appConfig.settings.mailBaseUrl;
  }

  _createClass(MailService, [{
    key: "sendRequestData",
    value: function () {
      var _sendRequestData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(patientId, fromName, to, body) {
        var url, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "".concat(this.baseUrl, "/requestdata");
                data = {
                  patientId: patientId,
                  fromName: fromName,
                  to: to,
                  body: body
                };
                _context.next = 4;
                return axios.post(url, data);

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendRequestData(_x, _x2, _x3, _x4) {
        return _sendRequestData.apply(this, arguments);
      }

      return sendRequestData;
    }()
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return MailService;
}();

export { MailService as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(MailService, "MailService", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/services/MailService.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();